var allowedSignatureAlg = ['RS256', 'RS384', 'RS512', 'PS256', 'PS384', 'PS512', 'ES256', 'ES256K', 'ES384', 'ES512', 'EdDSA'];
module.exports = allowedSignatureAlg;